<!-- Navigation -->
   <nav class="navbar navbar-inverse navbar-fixed-top" role="navigation" >
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="navbar-header" style="margin-bottom:10px;">
        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-ex1-collapse">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand" href="/Login" style="color:#FFE600;">&nbsp;&nbsp;
            <img src="./assets/static/EYwhite.png" 
            style="display:inline-block !important;vertical-align:bottom !important;margin-left:2vw;" 
            height="35" width="35">
            <span style="color:#Fff!important;font-size:22px;"></span>
        </a>

    </div>

    <!-- Top Menu Items -->
    <!-- Sidebar Menu Items - These collapse to the responsive navigation menu on small screens -->

    <br /><br />
    

    <div id="login-wrapper">
        <div style="border-radius:0 !important;margin-top:15vh  !important;margin-left:8vw!important;">
            <!-- <h3 style="color:#F3EDED;font-size:30px!important;font-weight:100;">Sign in</h3> -->
            <div class="panel panel-default" 
            style="display:table-cell;border-radius:0 !important;padding:10px 20px !important;background-color:#F3F2F0!important;">
    
                <div class="panel-body">
                    
                    <form (submit)= "login()" name="loginPage" novalidate="novalidate">
                        
                        
                        <!-- <h3 style="color:#666;font-size:20px!important;">Username</h3>
                        
                        <input type="email" id="username" name="username" placeholder="Type your username here" 
                            style="padding:10px;width:350px;height:50px;max-width:none !important;border:2px solid #e3e3e3 !important;">
                            <br>
                        
                            <h3 style="color:#666;font-size:20px!important;">Password</h3>
                        <input type="password" id="password" name="password" placeholder="Type your password here" 
                                style="padding:10px;width:350px;height:50px;max-width:none !important;border:2px solid #e3e3e3 !important;">
                             --><br>
                        <input type="submit" value="Sign In" class="btn btn-lg btn-primary loginbuttonStyle" 
                                style="margin-top:30px!important;margin-bottom:30px!important;" >
                            <br>
                    
                    </form>
                    <!-- @if (TempData["LoginError"] != null)
                    { 
                        <p class="alert alert-danger" id="successMessage">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> 
                            The user name or password was incorrect</p>
    
                    }
                    @using (Html.BeginForm("SignIn", "Login", FormMethod.Post, new { @name = "loginPage"}))
                    {
                        @Html.AntiForgeryToken() -->
                        
                       
                        <!-- <a href='#' id="login" ><button type="button" class="btn btn-lg btn-primary loginbuttonStyle" ><b></b>Sign In</button></a> -->
        
                    
                    <!-- <a href="#" style="color:#00a3ae;">Forgot your password?</a> -->
    
                </div>
            </div>
        </div>
    
    
    </div>
    
    <!-- /.navbar-collapse -->



</nav>
<nav class="navbar navbar-inverse navbar-fixed-bottom" role="navigation" 
    style="background-color:#fff !important;text-align:center;color:#999;padding:19px 10px;min-height:40px!important;">
    <span style="border-right:1px solid #999;padding-right:10px;">Ernst&Young 2016</span>
    <span style="border-right:1px solid #999;padding-right:10px;padding-left:10px;">Legal Information</span>
    <span style="padding-left:10px;">All Rights Reserved</span>
</nav>

    <!-- /#wrapper -->
   